<div class="row cta text-center" [ngClass]="context.elementClasses"
    [style.background-color]="context.backgroundColor">
    <div class="col-12 text-center">
        <span class="txt-regular">{{ context.title }}</span>
        <a href="{{ context.href }}" class="btn btn-cta"
           *ngIf="context.href">{{ context.buttonText }}</a>
        <a [routerLink]="context.innerLink" class="btn btn-cta"
           *ngIf="context.innerLink">{{ context.buttonText }}</a>
    </div>
</div>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/call-to-action/call-to-action.component.html